export default "__VITE_ASSET__9377111f__"